
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goi-tam-soat-nguy-co-dot-quy-tam-soat-tieu-duong",
      function () {
        return require("private-next-pages/goi-tam-soat-nguy-co-dot-quy-tam-soat-tieu-duong/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goi-tam-soat-nguy-co-dot-quy-tam-soat-tieu-duong"])
      });
    }
  